import $ from 'jquery';
import APPCONFIG from '../constants/Config';

function unwrapResponse(data) {
	return data && typeof data.response !== 'undefined' ? data.response : data;
}

function apiUrl(path) {
	return `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}${path}`;
}

export function fetchQuickPickList() {
	return $.ajax({
		type: 'GET',
		url: apiUrl('/checkout_quick_picks'),
		dataType: 'json',
	}).then((data) => {
		const payload = unwrapResponse(data);
		return payload && Array.isArray(payload.items) ? payload.items : [];
	});
}

export function fetchQuickPickStatus(entityType, entityPkey) {
	const params = new URLSearchParams({
		entity_type: entityType,
		entity_pkey: String(entityPkey),
	});

	return $.ajax({
		type: 'GET',
		url: `${apiUrl('/checkout_quick_picks/status')}?${params.toString()}`,
		dataType: 'json',
	}).then((data) => unwrapResponse(data));
}

export function addQuickPick(entityType, entityPkey) {
	return $.ajax({
		type: 'PUT',
		url: apiUrl('/checkout_quick_picks'),
		data: {
			object: JSON.stringify({
				entity_type: entityType,
				entity_pkey: entityPkey,
			}),
		},
		dataType: 'json',
	}).then((data) => unwrapResponse(data));
}

export function removeQuickPickByEntity(entityType, entityPkey) {
	return $.ajax({
		type: 'DELETE',
		url: apiUrl('/checkout_quick_picks/by_entity'),
		data: {
			object: JSON.stringify({
				entity_type: entityType,
				entity_pkey: entityPkey,
			}),
		},
		dataType: 'json',
	}).then((data) => unwrapResponse(data));
}

export function removeQuickPick(pkey) {
	return $.ajax({
		type: 'DELETE',
		url: `${apiUrl('/checkout_quick_picks')}/${pkey}`,
		dataType: 'json',
	}).then((data) => unwrapResponse(data));
}

export function reorderQuickPicks(items) {
	return $.ajax({
		type: 'POST',
		url: apiUrl('/checkout_quick_picks/reorder'),
		data: {
			object: JSON.stringify({
				items: items.map((item, index) => ({
					pkey: item.pkey,
					rank: index,
				})),
			}),
		},
		dataType: 'json',
	}).then((data) => unwrapResponse(data));
}
